export function deepClone (obj) {
	if (obj == null || typeof obj !== 'object') return obj;
	if (obj instanceof Date) return new Date(obj.getTime());
	// immutable and without own keys: walking it would turn a photo into {}
	// (lodash's cloneDeep kept them by reference too)
	if (obj instanceof Blob) return obj;
	if (Array.isArray(obj)) return obj.map(deepClone);

	const clone = {};
	for (const key of Object.keys(obj)) {
		clone[key] = deepClone(obj[key]);
	}
	return clone;
}

export function deepEqual (a, b) {
	if (a === b) return true;
	if (a == null || b == null || typeof a !== typeof b) return false;
	if (typeof a !== 'object') return false;
	if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();

	const keysA = Object.keys(a);
	const keysB = Object.keys(b);
	if (keysA.length !== keysB.length) return false;

	return keysA.every(key => Object.prototype.hasOwnProperty.call(b, key) && deepEqual(a[key], b[key]));
}
